import TotalRating from '../TotalRating'
import { useState } from 'react'
import { useMutation } from '@apollo/client'
import { CREATE_REVIEW } from '../../services/graphql/mutations/createProductReview'
import { useSelector } from 'react-redux'
import { selectMe } from '../../features/auth/authReducer'
import { useTranslation } from 'next-i18next'

export default function ReviewForm ({ plugin, onToggleChange, onReviewCreated }) {
  const { t } = useTranslation(['plugins'])
  const me = useSelector(state => selectMe(state.auth))
  const [createReview] = useMutation(CREATE_REVIEW)
  const [functionalityRating, setFunctionalityRating] = useState(0)
  const [documentationRating, setDocumentationRating] = useState(0)
  const [supportRating, setSupportRating] = useState(0)
  const [ratingTitle, setRatingTitle] = useState('')
  const [ratingText, setRatingText] = useState('')

  const create = async (e) => {
    e.preventDefault()

    try {
      await createReview({
        variables: {
          input: {
            user_id: me.id,
            product_id: plugin.id,
            rating_functionality: functionalityRating,
            rating_documentation: documentationRating,
            rating_support: supportRating,
            title: ratingTitle,
            rating_text: ratingText
          }
        }
      })
    } catch (e) {
    }

    setFunctionalityRating(0)
    setDocumentationRating(0)
    setSupportRating(0)
    setRatingTitle('')
    setRatingText('')
    onToggleChange(false)
    onReviewCreated()
  }

  return (
    <form className="my-4"
      onSubmit={create}
    >
      <div className="row my-4">
        <div className="col d-flex flex-column">
          <span className="fs-6 text-black-50">{t('detail.rating.functionality')}</span>
          <TotalRating rating={functionalityRating}
            canRate={true}
            onRatingChange={e => setFunctionalityRating(e)}
          />
        </div>
        <div className="col d-flex flex-column">
          <span className="fs-6 text-black-50">{t('detail.rating.documentation')}</span>
          <TotalRating rating={documentationRating}
            canRate={true}
            onRatingChange={e => setDocumentationRating(e)}
          />
        </div>
        <div className="col d-flex flex-column">
          <span className="fs-6 text-black-50">{t('detail.rating.support')}</span>
          <TotalRating rating={supportRating}
            canRate={true}
            onRatingChange={e => setSupportRating(e)}
          />
        </div>
      </div>
      <div className="my-2">
        <input required
          className="form-control my-2"
          type="text"
          placeholder={t('detail.rating.form.title')}
          value={ratingTitle}
          aria-label={t('detail.rating.form.title')}
          onChange={e => setRatingTitle(e.target.value)}
        />
        <textarea required
          aria-label={t('detail.rating.form.textarea')}
          className="form-control"
          value={ratingText}
          placeholder={t('detail.rating.form.textarea')}
          rows="5"
          onChange={e => setRatingText(e.target.value)}
        />
      </div>
      <button className="btn btn-outline-secondary my-4>"
        onClick={() => onToggleChange(false)}
      >{t('detail.rating.form.cancel')}</button>
      <button className="btn btn-outline-primary my-4 mx-3"
        type="submit"
      >{t('detail.rating.form.submit')}</button>
    </form>
  )
}
